import { useUser } from '@/queries/useUser';
import { MainContainer } from '@/components/layout/MainContainer/MainContainer';
import { Button } from '@/components/ui/button';
import { getNotionEntity, setupNotionIntegration } from '../lib/logic';
import { useEffect, useState } from 'react';

export function NotionIntegrationPage() {
    const { user } = useUser();
    const [documents, setDocuments] = useState<any[]>([]);

    useEffect(() => {
        getNotionEntity('page').then(setDocuments);
    }, []);

    return (
        <MainContainer>
            <div className='flex h-full flex-col items-center'>
                {user?.integrations?.notion ? (
                    <div>
                        <h1>Notion Integration</h1>
                        <p>Account ID: {user.integrations.notion.account_id}</p>
                        <p>Account Name: {user.integrations.notion.account_name}</p>
                        <p>Status: {user.integrations.notion.status}</p>
                        <p>Scopes: {user.integrations.notion.scopes.join(', ')}</p>
                        <p>Last Sync At: {user.integrations.notion.last_sync_at}</p>
                        <p>Sync Enabled: {user.integrations.notion.sync_enabled ? 'Yes' : 'No'}</p>
                        <p>Created At: {user.integrations.notion.created_at}</p>
                        <p>Updated At: {user.integrations.notion.updated_at}</p>

                        <div className='mt-10 flex flex-col items-center'>
                            <h1>Documents</h1>
                            <ul>
                                {documents.map(document => (
                                    <li key={document.id}>{document.name}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ) : (
                    <div className='flex flex-col items-center'>
                        <h1>No Notion Integration</h1>
                        <p>Please connect your Notion account to continue.</p>
                        <Button
                            variant='outline'
                            className='mt-4'
                            onClick={() => {
                                setupNotionIntegration();
                            }}
                        >
                            Connect Notion
                        </Button>
                        <Game />
                    </div>
                )}
            </div>
        </MainContainer>
    );
}
type Card = { value: string; suit: string; id: number };
const cards: Card[] = [
    { value: 'JACK', suit: 'SPADES', id: 1 },
    { value: '10', suit: 'HEARTS', id: 2 },
    { value: '2', suit: 'DIAMONDS', id: 3 },
];

const VALUE_MAP: Record<string, number> = {
    '2': 2,
    '3': 3,
    '4': 4,
    '5': 5,
    '6': 6,
    '7': 7,
    '8': 8,
    '9': 9,
    '10': 10,
    JACK: 11,
    QUEEN: 12,
    KING: 13,
    ACE: 14,
};

const MAX_ROUNDS = 3;
function Game() {
    const [isOver, setIsOver] = useState(false);
    const [rounds, setRounds] = useState<number[]>([]);
    const [winner, setWinner] = useState<number | null>(null);
    const [player1Hand, setPlayer1Hand] = useState<Card | null>(null);
    const [player2Hand, setPlayer2Hand] = useState<Card | null>(null);

    const checkHands = (p1Hand: Card | null, p2Hand: Card | null) => {
        if (rounds.length === MAX_ROUNDS) {
            setIsOver(true);
            const player1Wins = rounds.filter(val => val === 1).length;
            const didPlayer1Win = player1Wins > MAX_ROUNDS / 2;
            setWinner(didPlayer1Win ? 1 : 2);
            return;
        }

        const player1Value = p1Hand?.value ? VALUE_MAP[p1Hand?.value] : null;
        const player2Value = p2Hand?.value ? VALUE_MAP[p2Hand?.value] : null;
        if (!player1Value || !player2Value) return;

        const didPlayer1Win = player1Value > player2Value;
        setRounds(val => [...val, didPlayer1Win ? 1 : 2]);
    };

    const dealHand = () => {
        if (isOver) {
            setRounds([]);
            setIsOver(false);
            return;
        }

        const localHand = [...cards];
        const ranVal = Math.floor(Math.random() * localHand.length);
        const hand1 = localHand[ranVal];
        const player2Deck = localHand.filter(val => val.id !== hand1?.id);

        const hand2 = player2Deck[Math.floor(Math.random() * player2Deck.length)];

        setPlayer1Hand(hand1 ?? null);
        setPlayer2Hand(hand2 ?? null);
        checkHands(hand1 ?? null, hand2 ?? null);
    };

    useEffect(() => {}, []);
    return (
        <div className='mt-80 flex flex-col gap-3'>
            {!isOver && player1Hand && (
                <div>
                    Player 1: {player1Hand?.value} of {player1Hand?.suit}
                </div>
            )}
            {!isOver && player2Hand && (
                <div>
                    Player 2: {player2Hand?.value} of {player2Hand?.suit}
                </div>
            )}
            {!isOver && rounds.length > 0 && <div>Winner: Player {rounds[rounds.length - 1]}</div>}
            {isOver && <div className='mb-2'>GAME OVER!! Player {winner} has won!</div>}
            <button className='rounded-xl border bg-neutral-500/50 px-4 py-2' onClick={dealHand}>
                {!isOver ? (player1Hand && player2Hand ? 'Next Round' : 'Start') : 'Play again?'}
            </button>
        </div>
    );
}
